import { render, staticRenderFns } from "./GroupMembers.vue?vue&type=template&id=4f138ae2&"
import script from "./GroupMembers.vue?vue&type=script&lang=js&"
export * from "./GroupMembers.vue?vue&type=script&lang=js&"
import style0 from "./GroupMembers.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VAvatar,VBtn,VSelect})
